import React from 'react'

import SlideOne from './slides/slide-one'
import SlideTwo from './slides/slide-two'
import SlideThree from './slides/slide-three'
import SlideFour from './slides/slide-four'

export default function TeacherSlides ({ slideIndex }) {
  const slidesMap = {
    1: <SlideOne slideIndex={slideIndex} />,
    2: <SlideTwo slideIndex={slideIndex} />,
    3: <SlideThree slideIndex={slideIndex} />,
    4: <SlideFour slideIndex={slideIndex} />
  }
  return (
    <div className='teacher-slides slider-content' style={{ minHeight: I18n.locale === 'fr' ? 330 : 290 }}>
      {slidesMap[slideIndex]}
    </div>
  )
}
